<div class="custom-modal">
  <img *ngIf="config.img" class="info-circle mb-4" [src]="config?.img" alt="">
  <!-- <video *ngIf="config.video" width="320" height="240" controls>
    <source src="config?.video">
  </video> -->
  <h3 class="fs-24 fw-sbold text-center cl-primary mb-4 pb-2">
    {{ config.title }}
  </h3>

  <p class="fs-16 fw-sbold m-auto w-90 text-center cl-primary mb-3 pb-2" [innerHtml]="config?.message"></p>

  <div *ngIf="config?.cancelText; else oneBtn">
    <div class="d-flex justify-content-between doble">
      <button mat-button class="cancel" [ngClass]="config?.invertBtns ? 'order-1 ms-auto me-0' : 'me-auto ms-0'" (click)="cancel()">
        {{ config.cancelText }}
      </button>
      <button mat-button class="action" [ngClass]="config?.invertBtns ? 'order-0 me-auto ms-0 ' : 'ms-auto me-0'" (click)="accept()">
        {{ config.buttonText }}
      </button>
    </div>
  </div>

  <ng-template #oneBtn>
    <button mat-button class="action" (click)="accept()">
      {{ config.buttonText }}
    </button>
  </ng-template>

  <div class="modal-footer" *ngIf="config?.footer">
    {{ config.footer }}
  </div>
</div>
